import React from "react";
import { withStyles } from "@mui/styles";
import { FormControlLabel, Checkbox } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import PropTypes from "prop-types";

const propTypes = {
	classes: PropTypes.object.isRequired,
	checked: PropTypes.bool.isRequired,
	handleChange: PropTypes.func.isRequired,
	disableCheckbox: PropTypes.bool,
	label: PropTypes.string,
	style: PropTypes.object
};

const defaultProps = {
	disableCheckbox: false
};

const styles = {
	root: {
		color: "#828283",
		"&$checked": {
			color: "#69f0ae"
		}
	},
	checked: {},
	disabled: {
		opacity: 0.5,
		color: "#828283!important"
	}
};

const CBCheckbox = ({ classes, checked, handleChange, disableCheckbox, label, style, disableIcon }) => {
	const checkboxProperties = !disableIcon ? { icon: <CheckCircle />, checkedIcon: <CheckCircle /> } : {};
	return label ? (
		<FormControlLabel
			control={
				<Checkbox
					classes={{
						root: classes.root,
						checked: classes.checked,
						disabled: classes.disabled
					}}
					disabled={disableCheckbox}
					checked={checked}
					{...checkboxProperties}
					onChange={handleChange} data-testid="orion-components-cbcomponents-cbselection-controls-cbcheckbox-checkbox"
				/>
			}
			label={label}
			style={style}
		/>
	) : (
		<Checkbox
			classes={{
				root: classes.root,
				checked: classes.checked,
				disabled: classes.disabled
			}}
			disabled={disableCheckbox}
			checked={checked}
			{...checkboxProperties}
			onChange={handleChange} data-testid="orion-components-cbcomponents-cbselection-controls-cbcheckbox-checkbox-2"
		/>
	);
};

CBCheckbox.propTypes = propTypes;
CBCheckbox.defaultProps = defaultProps;

export default withStyles(styles)(CBCheckbox);
